module.exports = __webpack_public_path__ + "img/background-favourite.924d56ce.png";